import { createSlice } from "@reduxjs/toolkit";
import { CondicaoGeralSorteioModel } from "../../../models/condicaoGeralSorteio/condicaoGeralModel";
import { buscarCondicaoGeralSorteio, buscarCondicaoGeralSorteioPorId } from "../../../services/condicaoGeralSorteioService";
import { resetAll } from "../../actions/actions";

export interface CondicaoGeralSorteioState {
  //buscar condicao geral sorteio
  loading: boolean;
  busca: string | null;
  list: CondicaoGeralSorteioModel[];
  entity: CondicaoGeralSorteioModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: CondicaoGeralSorteioState = {
  //buscar condicao geral sorteio
  loading: false,
  busca: null,
  list: [],
  entity: {} as CondicaoGeralSorteioModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const condicaoGeralSorteioSlice = createSlice({
  name: "condicaoGeralSorteio",
  initialState,
  reducers: {
    //buscar condicao geral sorteio
    setBuscaCondicaoGeralSorteio: (state, action) => {
      state.busca = action.payload;
    },
    setEntityCondicaoGeralSorteio: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarCondicaoGeralSorteio: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarCondicaoGeralSorteio: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar
    builder.addCase(buscarCondicaoGeralSorteio.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarCondicaoGeralSorteio.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarCondicaoGeralSorteio.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar por id
    builder.addCase(buscarCondicaoGeralSorteioPorId.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarCondicaoGeralSorteioPorId.fulfilled, (state, action) => {
      state.entity = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarCondicaoGeralSorteioPorId.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar condicao geral sorteio
  setBuscaCondicaoGeralSorteio,
  setEntityCondicaoGeralSorteio,
  //internal
  setModalCadastrarCondicaoGeralSorteio,
  setModalDeletarCondicaoGeralSorteio,
} = condicaoGeralSorteioSlice.actions;

export default condicaoGeralSorteioSlice.reducer;
